import { css } from "@emotion/core";
import { color } from "../../theme/Theme";

export const loginIssueStyle = css({
  maxWidth: "20rem",
  marginTop: "7rem",
  ".ant-radio-wrapper": { marginBottom: "1rem" }
});
export const backToLoginStyle = css({
  color: color.black,
  top: "1rem",
  left: "1rem"
});
